import { fetchListIndividus } from '@/features/individus/store/actions';
import { utils } from '@/util';
import { MobiDocument } from './MobiDocument';
import { PaletteEnfantANDocument } from './PaletteEnfantANDocument';

export class Etablissement extends MobiDocument {

    // From Database
    private _id: string;
    private _rev: string;
    private id: number;
    private nom: string;
    private icon: string;
    private application: string;
    private logoetablissement_id: number;
    private logoetablissement_data: string;


    public constructor(etablissement: any) {
        super()
        this._id = etablissement._id;
        this._rev = etablissement._rev;
        this.id = etablissement.id;
        this.nom = etablissement.nom;
        this.icon = etablissement.icon;
        this.application = etablissement.application;
        this.logoetablissement_id = etablissement.logoetablissement_id;
        this.logoetablissement_data = utils.getSrcEtablissement(etablissement.logoetablissement_data);
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }
    public getIcon(): string {
        return this.icon;
    }
    public setIcon(icon: string): void {
        this.icon = icon
    }
    public getApplication(): string {
        return this.application;
    }
    public setApplication(application: string): void {
        this.application = application
    }
    public getLogoetablissement_id(): number {
        return this.logoetablissement_id;
    }

    public setLogoetablissement_id(logoetablissement_id: number): void {
        this.logoetablissement_id = logoetablissement_id;
    }

    public getLogoetablissement_data(): string {
        return this.logoetablissement_data;
    }

    public setLogoetablissement_data(logoetablissement_data: string): void {
        this.logoetablissement_data = logoetablissement_data;
    }

    public getActivites() {
        return this.memdb.find({
            doctype: "ActiviteDocument",
            fkey: "etablissement_id",
            fvalue: this.id

        })
    }

    public getPalette(): Array<number> {
        let listPaletteEnfantAN: Array<PaletteEnfantANDocument> = this.memdb.find({
            doctype: "PaletteEnfantANDocument",
            fkey: "etablissement_id",
            fvalue: this.id

        })
        return listPaletteEnfantAN.map((paletteEnfantAN: PaletteEnfantANDocument) => paletteEnfantAN.getId())
    }
}